var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip-link"},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.handleShow}},[_vm._v(_vm._s(_vm.linkText))]),_vm._v(" "),_c('div',[(_vm.showTip)?_c('div',{staticClass:"tip-text"},[_vm._t("default")],2):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-129d737d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TipLink.vue
// module id = null
// module chunks = 